import '@/plugins/vant'
import BridgeFunc from '@/plugins/bridgeFunc'
import CommonFunc from '@/plugins/commonFunc'
export default {
  install(Vue) {
    Vue.$bridgeFunc = Vue.prototype.$bridgeFunc = BridgeFunc
    Vue.$commonFunc = Vue.prototype.$commonFunc = CommonFunc
  }
}


// WEBPACK FOOTER //
// ./src/plugins/index.js